import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    gridItemContainer: {
      flexWrap: 'wrap',
      display: 'flex'
    },
    gridItem: {
      margin: '1%'
    },
    divider: {
      marginTop: theme.spacing(1)
    }
  })
